<template>
  <v-app>
    <router-view class="legacy-background" />
    <AppAlertDialog />
    <AppCodeConfirmation />
    <AppConfirmationDialog />
    <AppDownloader />
    <AppSnackbar />
    <vue-progress-bar />
  </v-app>
</template>

<script>
import AppAlertDialog from '@/components/AppAlertDialog'
import AppDownloader from '@/components/AppDownloader'
import AppCodeConfirmation from '@/components/AppCodeConfirmation'
import AppConfirmationDialog from '@/components/AppConfirmationDialog'
import AppSnackbar from '@/components/AppSnackbar'

export default {
  name: 'App',
  components: { AppAlertDialog, AppCodeConfirmation, AppConfirmationDialog, AppDownloader, AppSnackbar },
  data () {
    return {
      //
    }
  },
  mounted () {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish()
  },
  created () {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  start the progress bar
      this.$Progress.start()
      //  continue to next page
      next()
    })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => this.$Progress.finish())
  }
}
</script>
<style>
  a {
    text-decoration: none
  }
  main {
    min-height: 100vh !important;
  }

  .site-logo {
    max-height: 25px
  }

  .rounded-card{
    border-radius: 15px !important;
  }

  .pointer {
    cursor: pointer;
  }

  .v-list-item {
    user-select: text !important;
  }

  .v-application a {
    color: #1287cd !important;
  }

  .legacy-background {
    background: #fafafa !important;
  }

  .vuejs3-datepicker__calendar-topbar {
    background-color: royalblue !important;
  }

  .vuejs3-datepicker__calendar .cell.selected {
    background-color: royalblue !important;
  }

  .color-black {
    color: black !important;
  }

  .v-list-subheader__text {
    white-space: normal !important;
  }

  .v-list-item-title {
    white-space: normal !important;
  }

  .trainer-cutoff-table {
    font-size: 15px;
  }

  .trainer-cutoff-table .current-cycle {
    background-color: #fff2cc !important;
  }

  td .current-cycle {
    background-color: #fff2cc !important;
  }

  .float-right {
    float: right;
  }
</style>
